module.exports = __webpack_public_path__ + "img/dawn_icon.26217b93.svg";